import cards from '@/store/modules/storage/cards/cards';

export default {
    cards,
};
